var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"34","y1":"17.5","x2":"10","y2":"17.5","stroke":"black","strokeWidth":"3","key":1}),React.createElement("line",{"x1":"34","y1":"27.5","x2":"10","y2":"27.5","stroke":"black","strokeWidth":"3","key":2}),React.createElement("circle",{"cx":"26.5","cy":"17.5","r":"3","transform":"rotate(90 26.5 17.5)","fill":"white","stroke":"black","strokeWidth":"3","key":3}),React.createElement("circle",{"cx":"17.5","cy":"27.5","r":"3","transform":"rotate(90 17.5 27.5)","fill":"white","stroke":"black","strokeWidth":"3","key":4})]);
}

Filter.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
